<template>
  <div class="home-view">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "HomeView"
}
</script>

<style scoped>
.home-view {
  width: 100%;
  min-height: 100vh;
}
</style>